<template>
  <v-container>
    <!-- Top bar with loading indicator -->
    <v-app-bar
      flat
      color="primary"
      role="navigation"
      aria-labelledby="communities-title"
    >
      <v-toolbar-title
        id="communities-title"
        class="text-body-2"
      >
        {{ $t("components.communities.title") }}
      </v-toolbar-title>
      <v-progress-linear
        v-show="isLoading"
        color="accent"
        indeterminate
        aria-label="Loading"
        role="status"
      />
    </v-app-bar>

    <!-- Communities Grid -->
    <v-layout
      wrap
      role="region"
      aria-label="List of communities"
    >
      <v-flex
        v-for="community in communities"
        :key="community.id"
        v-bind="{
          [`xs${community.flexExtraSmall} sm${community.flexSmall} md${community.flexMedium} lg${community.flexLarge}`]: true
        }"
      >
        <v-card
          v-if="community.isActive"
          class="mb-4"
          :aria-labelledby="`community-title-${community.id}`"
          role="group"
          :aria-label="$t(community.title)"
        >
          <!-- Community Image -->
          <v-img
            :alt="$t(community.title)"
            :src="community.img"
            height="100px"
            class="elevation-1"
            role="img"
          />

          <!-- Community Title & Subtitle -->
          <v-card-title primary-title>
            <div>
              <h3
                :id="`community-title-${community.id}`"
                class="h5 mb-1"
              >
                {{ $t(community.title) }}
              </h3>
              <span class="grey--text text-subtitle-2">
                {{ $t(community.subtitle) }}
              </span>
            </div>
          </v-card-title>

          <!-- Buttons -->
          <v-card-actions>
            <v-btn
              :aria-label="$t('components.communities.buttons.view')"
              text
              color="accent"
              @click="viewCommunityCard(community.link)"
              @keyup.enter="viewCommunityCard(community.link)"
            >
              {{ $t("components.communities.buttons.view") }}
            </v-btn>
            <v-spacer />
            <v-btn
              :aria-expanded="isCardVisible(community.id) ? 'true' : 'false'"
              :aria-controls="`community-details-${community.id}`"
              :color="isCardVisible(community.id) ? 'accent' : ''"
              icon
              @click="toggleCommunityCard(community.id)"
              @keyup.enter="toggleCommunityCard(community.link)"
            >
              <v-icon>
                {{
                  isCardVisible(community.id)
                    ? "keyboard_arrow_down"
                    : "keyboard_arrow_up"
                }}
              </v-icon>
            </v-btn>
          </v-card-actions>

          <!-- Slide-down Description -->
          <v-slide-y-transition>
            <v-card-text
              v-show="isCardVisible(community.id)"
              :id="`community-details-${community.id}`"
              class="pt-0"
            >
              {{ $t(community.brief) }}
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import communities from "@/constants/communities.js";

export default {
    name: "Communities",
    data() {
        return {
            communities: communities.list,
            cardsOptions: [],
            isLoading: false
        }
    },
    beforeMount() {
        this.isLoading = true;
        // Setup our state
        this.communities.map(({ id }) => {
            this.cardsOptions[id] = {
                visibile: false
            };
        });
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        /**
         * Will handle the toggle of showing the text for the current card
         */
        toggleCommunityCard(id) {
            this.cardsOptions.splice(id, 1, {
                ...this.cardsOptions[id],
                visibile: !this.cardsOptions[id].visibile
            });
        },
        /**
         * Will handle the view community card to external url
         */
        viewCommunityCard(link) {
            if (link) {
                // track event
                // this.$ga.event("commuities-list", "link", link);
                // open link
                window.open(link);
            }
        },
        /**
         * Check if card visible or not
         */
        isCardVisible(id) {
            return this.cardsOptions[id].visibile;
        }
    }
};
</script>
